import React, { useState } from 'react'
import './ChatScreen.css'
import { Avatar } from '@material-ui/core'

const ChatScreen = () => {
    const [input, setInput] = useState('')
    const [message, setMessage] = useState([
        {
            name: 'Vitalik',
            image: 'https://tk.media/storage/uploads/articles/0/871-article20190827105858.jpg',
            message: 'tomorrow is not today'
        },
        {
            name: 'Vitalik',
            image: 'https://tk.media/storage/uploads/articles/0/871-article20190827105858.jpg',
            message: 'Do you understand?'
        },
        {
            message: 'Yes, you is admiral!'
        }
    ])

const handleSend = e => {
    e.preventDefault()

    setMessage([...message, { message: input }])
    setInput('')
}

    return (
        <div className='chatScreen'>
            <p className='chatScreen__timestamp'>
                YOU MATCHED WITH VITALIK ON 20/08/2020
            </p>
            {message.map((message) => (
                message.name ? (
                    <div className='chatScreen__message'>
                    <Avatar
                        className='chatScreen__image'
                        alt={message.name}
                        src={message.image}
                    />
                    <p className='chatScreen__text'>{message.message}</p>
                </div>
                ) : (
                    <div className='chatScreen__message'>
                   
                    <p className='chatScreen__textUser'>{message.message}</p>
                </div>
                )
            ))}
            <div>
                <form className='chatScreen__input'>
                    <input 
                    value={input}
                    onChange={e => setInput(e.target.value)}
                    className='chatScreen__inputField'
                    placeholder='Type a message...' 
                    type='text' />
                    <button onClick={handleSend} type='submit' className='chatScreen__inputButton'>SEND</button>
                </form>
            </div>
        </div>
    )
}

export default ChatScreen